import { Component, HostListener } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { DpSuccessMessageComponent } from '../../../common-component/dp-success-message/dp-success-message.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { interval } from 'rxjs/internal/observable/interval';
import { map, switchMap, take } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { AuthTransmissionService } from '../../../services/raintree/Transmission/auth-transmission.service';
import {
  SendEmailOTPResponse,
  SendMobileOTPResponse,
  VerifyEmailOTPResponse,
  VerifyMobileOTPResponse,
  VerifySignUpResponse,
} from '../../../services/raintree/interfaces/raintree-response';
import { SnackbarService } from '../../../services/common/snackbar.service';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { ToastrService } from 'ngx-toastr';
import { RequestMapper } from '../../../request-mapper';
import { CanComponentDeactivate } from '../../../guard/unsaved-changes.guard';

@Component({
  selector: 'app-create-account-verification',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './create-account-verification.component.html',
  styleUrl: './create-account-verification.component.scss',
})
export class CreateAccountVerificationComponent implements CanComponentDeactivate {
  verifySignUpPayload: any;
  constructor(
    public dialog: MatDialog,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private toaster: ToastrService,
    private _authTransmissionService: AuthTransmissionService,
    private http: HttpClient,
    private snackbar: SnackbarService
  ) {}

  // @HostListener('window:beforeunload', ['$event'])
  // unloadNotification($event: BeforeUnloadEvent): boolean {
  //   const confirmationMessage = confirm('Are you sure you want to leave? ');
  //   if (confirmationMessage) {
  //     localStorage.clear();
  //     this.router.navigate([RequestMapper.LOGIN]);
  //     return true;
  //   }
  //   //$event.returnValue = false;
  //   return false;
  // }

  isResendDisabled: boolean = true;
  timerMessage: string = '';
  emailPayload: any;
  verifyEmailPayload: any;
  verifyMobilePayload: any;
  minutes: number = 3;
  seconds: number = 0;
  countdownCompleted: boolean = false;
  private intervalId: any;

  mobilePayload: any;

  sessionIdUser: string | null = null;
  sessionIdEmail: string | null = null;
  sessionIdMobile: string | null = null;
  email: string | null = null;
  phone: string | null = null;
  isSpanDisabledForEmail = true;
  isSpanDisabledForMobile = true;
  countdown = 180;
  countdownForMobile = 180;
  countdownIntervalForMobile: any;
  countdownForEmail = 180;
  countdownIntervalForEmail: any;
  hasUnsavedChanges: boolean = true;
  loginClicked:boolean=true
  
  signInFormVerification = new FormGroup({
    phoneOtp: new FormControl('', [Validators.required]),
    emailOtp: new FormControl('', [Validators.required]),
  });
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    if (this.hasUnsavedChanges && this.sessionIdUser && this.sessionIdEmail && this.sessionIdMobile && this.email && this.phone && this.loginClicked) {
      
      $event.returnValue = true;
    }
   
  
}
  ngOnInit() {
    this.startCountdownForMobile();
    this.startCountdownForEmail();

    this.sessionIdUser = localStorage.getItem('sessionIdUser') || null;
    this.sessionIdEmail = localStorage.getItem('sessionIdEmail') || null;
    this.sessionIdMobile = localStorage.getItem('sessionIdMobile') || null;
    this.email = localStorage.getItem('email') || null;
    this.phone = localStorage.getItem('phone') || null;
    console.log(this.email,"email")

    if (!this.sessionIdUser || !this.sessionIdEmail || !this.sessionIdMobile || !this.email || !this.phone) {
      
      console.log("redirecccccccctttttttttt")
      this.router.navigate(['/create-account']);
  }

    // this.activateRoute.queryParams.subscribe((params) => {
    //   console.log(atob(params['email']));
    //   this.sessionIdUser = params['sessionIdUser']
    //     ? atob(params['sessionIdUser'])
    //     : null;
    //   this.sessionIdEmail = params['sessionIdEmail']
    //     ? atob(params['sessionIdEmail'])
    //     : null;
    //   this.sessionIdMobile = params['sessionIdMobile']
    //     ? atob(params['sessionIdMobile'])
    //     : null;
    //   this.email = params['email'] ? atob(params['email']) : null;
    //   this.phone = params['phone'] ? atob(params['phone']) : null;
    //   console.log(params['email'], 'without atob');
    // });
    // console.log(this.phone, this.email, 'phone');
  }

  canDeactivate(): boolean {
    if (this.hasUnsavedChanges && this.sessionIdUser && this.sessionIdEmail && this.sessionIdMobile && this.email && this.phone && this.loginClicked)  {
   
      return confirm('You have unsaved changes! If you leave, your changes will be lost.');     
    }
    return true;
  }

  opensuccessdialog() {
    
    this.verifySignUpPayload = {
      sessionIdUser: this.sessionIdUser,
      sessionIdEmail: this.sessionIdEmail,
      sessionIdMobile: this.sessionIdMobile,
      mobileOtp: this.signInFormVerification.get('phoneOtp')?.value,
      emailOtp: this.signInFormVerification.get('emailOtp')?.value,
    };
    this._authTransmissionService
      .getVerifySignUp(this.verifySignUpPayload)
      .subscribe({
        next: (response: VerifySignUpResponse) => {
          console.log(response);
          this.loginClicked=false
    this.dialog.open(DpSuccessMessageComponent, {
      panelClass: 'common-pannel-dialog-container',
      data: {
        mainHeading: 'Your account was created successfully!',
        subHeading: 'You can login to DP using the new credentitals',
        buttonValue: 'Login now',
        routeNavigate: true,
        routerLink: RequestMapper.LOGIN,
      },
      
    });
          this.router.navigate(['/create-account']);
          
        },
        error: (error) => {
          console.log(error);

          this.snackbar.snackbar(error, 'ok', 'success-snackbar');
        },
      });
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }
  resendEmailOtp() {
    this.emailPayload = {
      email: this.email,
      sessionId: this.sessionIdUser,
    };
    this._authTransmissionService.getSentEmailOTP(this.emailPayload).subscribe({
      next: (response: SendEmailOTPResponse) => {
        console.log(response);
        this.sessionIdEmail = response.data.sessionId;
      },
      error: (error) => {
        console.log(error);

        this.snackbar.snackbar(error, 'ok', 'success-snackbar');
      },
    });
  }
  resendMobileOtp() {
    this.mobilePayload = {
      mobileNo: this.phone,
      sessionId: this.sessionIdUser,
    };
    this._authTransmissionService
      .getSentMobileOTP(this.mobilePayload)
      .subscribe({
        next: (response: SendMobileOTPResponse) => {
          console.log(response);
          this.sessionIdMobile = response.data.sessionId;
        },
        error: (error) => {
          console.log(error);

          this.snackbar.snackbar(error, 'ok', 'success-snackbar');
        },
      });
  }

  verifyEmailOtp() {
    this.verifyEmailPayload = {
      sessionId: '',
      email: this.signInFormVerification.get('emailOtp')?.value,
    };
    this._authTransmissionService
      .getVerifyEmailOTP(this.verifyEmailPayload)
      .subscribe({
        next: (response: VerifyEmailOTPResponse) => {
          console.log(response);
        },
        error: (error) => {
          console.log(error);

          this.snackbar.snackbar(error, 'ok', 'success-snackbar');
        },
      });
  }

  startCountdownForMobile(): void {
    this.countdownIntervalForMobile = setInterval(() => {
      if (this.countdownForMobile > 0) {
        this.countdownForMobile--;
      } else {
        this.isSpanDisabledForMobile = false;
        clearInterval(this.countdownIntervalForMobile);
      }
    }, 1000);
  }
  startCountdownForEmail(): void {
    this.countdownIntervalForEmail = setInterval(() => {
      if (this.countdownForEmail > 0) {
        this.countdownForEmail--;
      } else {
        this.isSpanDisabledForEmail = false;
        clearInterval(this.countdownIntervalForEmail);
      }
    }, 1000); // Update every second
  }
  onResendForMobile(): void {
    this.resendMobileOtp();
    // Disable the span and restart the countdown
    this.isSpanDisabledForMobile = true;
    this.countdownForMobile = 180; // Reset countdown
    this.startCountdownForMobile();
  }
  onResendForEmail(): void {
    this.resendEmailOtp();

    this.isSpanDisabledForEmail = true;
    this.countdownForEmail = 180;
    this.startCountdownForEmail();
  }

  ngOnDestroy(): void {}
}
